import React, { Fragment, useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { useDispatch, useSelector } from 'react-redux';

import { editarBreadcrumb } from '../../../actions/breadcrumb';
import { buscarIngresos, filtrarIngresos } from '../../../actions/ingresos';

import { formatNumber } from '../../../utils/generalFunctions';

import FiltrosIngreso from './FiltrosIngreso';
import NuevoIngreso from './NuevoIngreso';
import EditarIngreso from './EditarIngreso';
import EliminarIngreso from './EliminarIngreso';

const Ingresos = () => {

    let rutasBread = [
        {
            activo: true,
            nombre: 'Ingresos',
            path: '/egresos/ingresos'
        }
    ];

    const dispatch =  useDispatch();

    const { usuario } = useSelector(state => state.auth);
    const { listado } = useSelector(state => state.ingresos);

    const [ingresos, setIngresos] = useState([]);

    const [ingresoAgregar, setIngresoAgregar] = useState(null);
    const [ingresoEditar, setIngresoEditar] = useState(null);
    const [ingresoEliminar, setIngresoEliminar] = useState(null);

    const paginationOptions = { rowsPerPageText: 'Filas por página', rangeSeparatorText: 'de' };

    const columns = [
        {
            name: 'Concepto',
            selector: row => row.concepto,
            grow: 4
        },
        {
            name: 'Método de pago / cobro',
            selector: row => row.metodo?.nombre || 'Sin definir',
            grow: 1.5
        },
        {
            name: 'Fecha',
            grow: 2,
            cell: item => item.fecha && item.fecha != '0000-00-00' ? new Date(item.fecha).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' }) + ' ' + new Date(item.fecha).toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' }) : 'Sin definir'
        },
        {
            name: 'Monto',
            selector: row => formatNumber(row.monto, 2, '$ ', '')
        },
        {
            name: '',
            cell: row => {
                return(
                    <div className="text-right w-100">
                        {
                            usuario?.permisos?.ingresos?.eliminar &&
                                <button type="button" className="btn btn-sm btn-link px-2 float-end" onClick={() => handleEliminarIngreso(row)}><i className="fas fa-trash text-danger"></i></button>
                        }
                        {
                            usuario?.permisos?.ingresos?.editar &&
                                <button type="button" className="btn btn-sm btn-link px-2 float-end" onClick={() => handleEditarIngreso(row)}><i className="fas fa-edit text-warning"></i></button>
                        }
                    </div>
                )
            }
        }
    ];

    /* Filtros de busqueda */
    const handleFiltrosBusqueda = () => {
        dispatch(filtrarIngresos(true));
    }

    /* Crear ingreso */
    const handleAgregarIngreso = (ingreso) => {
        setIngresoEditar(null);
        setIngresoEliminar(null);

        setIngresoAgregar(ingreso);        
    }

    /* Editar ingreso */
    const handleEditarIngreso = (ingreso) => {
        setIngresoAgregar(null);
        setIngresoEliminar(null);

        setIngresoEditar(ingreso);
    }

    /* Eliminar ingreso */
    const handleEliminarIngreso = (ingreso) => {
        setIngresoAgregar(null);
        setIngresoEditar(null);

        setIngresoEliminar(ingreso);
    }

    useEffect(() => {
        dispatch(buscarIngresos({
            concepto: null, 
            metodo: null, 
            fecha_inicio: null, 
            fecha_fin: null
        }));
    }, []);

    useEffect(() => {
        setIngresos(listado);
    }, [listado]);

    useEffect(() => {
        dispatch(editarBreadcrumb(rutasBread));
    }, [rutasBread]);

    return (
        <Fragment>

            <FiltrosIngreso />
            <NuevoIngreso ingreso={ingresoAgregar} reestablecerIngreso={handleAgregarIngreso} />
            <EditarIngreso ingreso={ingresoEditar} reestablecerIngreso={handleEditarIngreso} />
            <EliminarIngreso ingreso={ingresoEliminar} reestablecerIngreso={handleEliminarIngreso} />

            <div className="row">
                <div className="col-md-12 px-4 pb-4">
                    <h3 className="mb-3 mt-5">Ingresos</h3>

                    <div className="d-flex justify-content-end">
                        <button type="button" className="btn btn-secondary mx-1" onClick={() => handleFiltrosBusqueda()}>Filtros de búsqueda</button>
                        {
                            usuario?.permisos?.ingresos?.agregar &&
                                <button type="button" className="btn btn-primary mx-1" onClick={() => handleAgregarIngreso({ })}>Agregar ingreso</button>
                        }
                    </div>

                    <div className="mt-3">
                        <DataTable 
                            columns={columns}
                            data={ingresos}
                            pagination
                            paginationPerPage={20}
                            paginationRowsPerPageOptions={[5, 10, 20, 50]}
                            paginationComponentOptions={paginationOptions}
                            highlightOnHover={true}
                        />
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default Ingresos;